{
  "ConfigureAgents_Add_Title": "Neuen Agenten hinzufügen",
  "ConfigureAgents_Modify_Title": "Agent ändern",
  "ConfigureAgents_PromptMessage": "Sind Sie sicher, dass Sie dieses Fenster schließen wollen? Alle geänderten Konfigurationen gehen beim Schließen verloren.",
  "ConfigureAgents_PromptConfirm": "Ja",
  "ConfigureAgents_PromptCancel": "Abbrechen",
  "ConfigureAgents_Tabs_Details": "Agent Details",
  "ConfigureAgents_Tabs_Advanced": "Fortgeschrittene",
  "ConfigureAgents_Tabs_Omnichannel": "Omnikanal",
  "ConfigureAgents_Footer_Help": "Hilfe?",
  "ConfigureAgents_Footer_Submit": "Speichern Sie",
  "ConfigureAgents_Footer_Cancel": "Abbrechen",
  "NAME": "ConfigureAgents"
}